import axios from 'axios'
import decode from 'jwt-decode'
import anime from 'animejs'
import { DateTime } from 'luxon'

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

axiosClient.interceptors.request.use((config) => {
    config = Object.assign({}, config, { headers: { authorization: `JWT ${getToken()}` } })
    return config
})

export function getHTTPClient() {
    return axiosClient
}

export function checkStatusCode(status) {
    if (status === 401)
        window.location.reload()
    else if (status === 403)
        window.location.href = '/nao-autorizado'
    else if (status === 502)
        window.location.href = '/servico-indisponivel'
}

export function getToken() {
    return localStorage.getItem('JT')
}

export function setToken(token) {
    return new Promise(resolve => {
        localStorage.setItem('JT', token)
        return resolve()
    })
}

export const isLoggedIn = async () => {
    let token = getToken(), cookie = decodeURIComponent(document.cookie).split("dpnet=")[1]
    return await handleCookie(cookie, token)
}

const handleCookie = async (cookie, token) => {
    if (!cookie)
        return false
    else if (cookie && token) {
        token = decode(token)
        let ck = decode(cookie)
        if (ck.token !== token.issuedFor) {
            // backend revalidate
            return getHTTPClient()({
                method: 'POST',
                url: '/auth',
                data: { cookie }
            })
            .then(async response => {
                if (response.data && response.data.token) {
                    await setToken(response.data.token)
                    return true
                } else 
                    return false
            })
            .catch(err => false)

        } else {
            let now = Date.now() / 1000
            if (now > token.exp) {
                // backend revalidate
                return getHTTPClient()({
                    method: 'POST',
                    url: '/auth',
                    data: { cookie }
                }).then(async response => {
                    if (response.data && response.data.token) {
                        await setToken(response.data.token)
                        return true
                    } else 
                        return false
                })
                .catch(err => false)
            } else 
                return true
        }
    } else if (cookie && !token) {
        // backend revalidate
        return getHTTPClient()({
            method: 'POST',
            url: '/auth',
            data: { cookie }
        }).then(async response => {
            if (response.data && response.data.token) {
                await setToken(response.data.token)
                return true
            } else 
                return false
        })
        .catch(err => false)
    }
}

export function getDecodedToken() {
    let token = getToken()
    if (token === null)
        return false
    else {
        return decode(token)
    }
}

export function logout() {
    return new Promise(resolve => {
        localStorage.clear()
        return resolve()
    })
}

export function formatCNPJ(number) {
    return !!number ? number.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5") : ''
}

export function groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
            map.set(key, [item])
        } else {
            collection.push(item)
        }
    })
    return map
}

export function parseQueryString(query) {
    return JSON.parse('{"' + decodeURI(query).replace("?", "").replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function toMoney(value) {
    value = parseFloat(value).toFixed(2)
    let x = value.split('.'), x1 = x[0], x2 = '', rgx = /(\d+)(\d{3})/

    if (x.length > 1) {
        if (x[1].length < 2)
            x[1] += '0'
        x2 = ',' + x[1]
    } else
        x2 = ',00'

    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1.$2')
    return x1 + x2
}

export function emissToDate(emiss) {
    return DateTime.fromFormat(emiss.toString(), 'yyyyMMddHHmmss').toFormat('dd/MM/yyyy HH:mm:ss')
}

export function dateIdToDate(date) {
    return DateTime.fromFormat(date.toString(), 'yyyyMMdd').toFormat('dd/MM/yyyy')
}

export const showNotification = async (text, type = 'alert-info', time = 4000) => {

    const qtde = document.getElementsByClassName('ntx').length
    const area = document.getElementById('notification-area')
    const notification = document.createElement('DIV')
    const closeBtn = document.createElement('BUTTON')
    closeBtn.classList.add('close')
    closeBtn.innerHTML = '<span aria-hidden="true">&times;</span>'
    notification.classList.add('nt', 'alert', 'alert-dismissible', 'hidden', type)
    notification.insertAdjacentElement('afterbegin', closeBtn)
    notification.appendChild(document.createTextNode(text))
    area.insertAdjacentElement('beforeend', notification)
    await anime({
        targets: notification,
        opacity: 1,
        duration: 1000,
        easing: 'linear'
    }).finished

    const id = setTimeout(async () => {
        await anime({
            targets: notification,
            opacity: 0,
            duration: 1000,
            easing: 'linear'
        }).finished
        while (area.hasChildNodes())
            area.removeChild(area.lastChild)
    }, time + ((qtde + 1) * 1500))

    closeBtn.addEventListener('click', () => {
        clearTimeout(id)
        closeNotificationAction(notification)
    })

}

const closeNotificationAction = async node => {
    const area = document.getElementById('notification-area')
    await anime({
        targets: node,
        opacity: 0,
        duration: 1000,
        easing: 'linear'
    }).finished
    while (area.hasChildNodes())
        area.removeChild(area.lastChild)

}

export const numFormat = (value, decimalPlaces = 2, symbol = false) => {
    let formatedValue = parseFloat(value).toFixed(decimalPlaces)
        .replace('.', ',')
        .replace(/\d(?=(\d{3})+,)/g, '$&.')

    return (symbol) ? `R$ ${formatedValue}` : formatedValue
}